export enum BettingOfferStatus {
	Inactive = 0,
	Active = 1,
	Win = 2,
	WinWithReducedOdds = 3,
	Lose = 4,
	Refund = 5,
	RefundHalfBetAndWinOtherHalf = 6,
	Cancelled = 8,
	Cashout = 9,
}
